import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Image,
  OverlayTrigger,
  Row,
  Spinner,
  Stack,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import dockLogo from "../../images/dock.png";
import {
  getUserDetails,
  listUsers,
  mfaSettingToggle,
  updateUserProfile,
} from "../../redux/Actions/userAction";
import Loader from "../../components/Loader";
import Message from "../../components/Message";
import { faInfoCircle, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { message } from "antd";

const AdminProfilePage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(false);
  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.userDetails);
  const { loading, error, user } = userInfo;
  const {
    loading: updateLoading,
    sucess: updateSuccess,
    error: updateError,
  } = useSelector((state) => state.userUpdate);

  const [checked, setChecked] = React.useState(user?.isMFAEnabled);
  const [toggleLoading, setToggleLoading] = useState(false);

  const submiHandler = (e) => {
    e.preventDefault();
    if (password == confirmPassword && password != "") {
      setPasswordMatch(false);
      const updatedUser = {
        name,
        email,
        password,
      };
      dispatch(updateUserProfile(updatedUser));
      setPassword("");
      setConfirmPassword("");
    } else {
      setPasswordMatch(true);
    }
  };

  const handleMFAToggle = (event) => {
    setToggleLoading(true);
    const payload = {
      userId: user?._id,
      isRoleUser: user?.isRoleUser,
      enableMFA: event?.target?.checked,
    };
    dispatch(mfaSettingToggle(payload))
      .then((result) => {
        if (result?.success) {
          setChecked(result.isMFAEnabled);
          message.success(
            result?.message ?? "MFA setting updated successfully"
          );
        }
      })
      .catch((err) => {
        message.error("Failed to update MFA setting");
      })
      .finally(() => setToggleLoading(false));
  };

  useEffect(() => {
    let hideLoading;
    if (updateLoading) {
      hideLoading = message.loading("Updating", 0);
    }
    if (updateSuccess) {
      if (hideLoading) hideLoading();
      message.success("Password updated");
    }
    if (updateError) {
      if (hideLoading) hideLoading();
      message.error(updateError || "Failed to update password");
    }
    return () => {
      if (hideLoading) hideLoading();
    };
  }, [updateLoading, updateSuccess, updateError]);

  useEffect(() => {
    dispatch(getUserDetails());
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      setName(user.companyName);
      setEmail(user.email);
    }
  }, [user]);

  const styles = {
    shadow: {
      boxShadow:
        " rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    },
  };
  return (
    <>
      <Row className="h-100 mt-md-5 p-3 gap-3 justify-content-center">
        <Col
          md={3}
          xs={12}
          style={styles.shadow}
          className="border border-1 rounded-3 px-2 py-5 mx-3"
        >
          <Row className="justify-content-center">
            {user && user.isSuperAdmin ? (
              <Col sm={7}>
                <Image src={dockLogo} alt="Dock" roundedCircle fluid />
              </Col>
            ) : (
              <Col xs="auto" className="border border-1 p-5 rounded-circle">
                <FontAwesomeIcon
                  icon={faUser}
                  size="4x"
                  className="text-primary"
                />
              </Col>
            )}
          </Row>
          <Row className="my-3">
            <h4 className="text-center text-break m-0">{name}</h4>
            <span className="text-center text-break text-muted">{email}</span>
          </Row>
        </Col>
        <Col
          md={8}
          xs={12}
          style={styles.shadow}
          className="border border-1 rounded-3"
        >
          <Card border="0">
            <Card.Body>
              <div className="px-3">
                <Card.Title className="text-center text-muted">
                  Edit Details
                </Card.Title>
              </div>
              <hr />
              <Row>
                {updateLoading && <Loader />}
                {updateError && <Message>{updateError}</Message>}
                <Form onSubmit={submiHandler}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Company Name</Form.Label>
                        <Form.Control
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="text"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <h5 className="my-3 text-muted">Change Password</h5>
                  <Row>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                      <Form.Label>New Password</Form.Label>
                      <Form.Control
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                      <Form.Label>Confirm New Password</Form.Label>
                      <Form.Control
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      {passwordMatch ? (
                        <Form.Text className="text-danger">
                          Password does not match
                        </Form.Text>
                      ) : (
                        <></>
                      )}
                    </Form.Group>
                  </Row>
                  <Row>
                    <Col sm="auto" className="ms-auto">
                      <Button variant="success" type="submit">
                        Save Changes
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Row>
              <hr />
              <Row>
                <Card.Title className="text-muted">
                  Additional Settings
                </Card.Title>
                <Form>
                  <Form.Group as={Row} className="align-items-center mb-3">
                    <Form.Label column sm="8" className="mb-0">
                      Two-Factor Authentication{" "}
                      <OverlayTrigger
                        placement="right"
                        overlay={
                          <Tooltip>
                            Adds extra login protection using a one-time code
                            sent to your email.
                          </Tooltip>
                        }
                      >
                        <span
                          className="text-muted"
                          style={{ cursor: "pointer" }}
                        >
                          <FontAwesomeIcon icon={faInfoCircle} color="info" />
                        </span>
                      </OverlayTrigger>
                    </Form.Label>

                    <Col sm="4">
                      <Stack
                        direction="horizontal"
                        gap={1}
                        className="justify-content-end"
                      >
                        <Form.Check
                          type="switch"
                          id="mfa-toggle-switch"
                          checked={checked}
                          onChange={handleMFAToggle}
                          disabled={toggleLoading}
                        />
                        {toggleLoading && (
                          <Spinner animation="border" size="sm" />
                        )}
                      </Stack>
                    </Col>
                  </Form.Group>
                </Form>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AdminProfilePage;
